module.exports = __webpack_public_path__ + "img/admin-bg.2f178bcf.svg";